export function getMetaContent(name: string): string | undefined {
  const header = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`) || undefined;

  return header ? header.content : undefined;
}

export function getAuthenticityToken(): string | undefined {
  return getMetaContent('csrf-token');
}

/**
 * The server sends a new CSRF token when it changes, e.g. after signing in. Store it so later requests use it.
 */
export function updateAuthenticityToken(response: Response): void {
  const token = response.headers.get('X-CSRF-Token');
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');

  if (token && meta) {
    meta.content = token;
  }
}

export function authenticityHeader(options?: Record<string, string>): Record<string, string> {
  return Object.assign({}, options || {}, {
    'X-CSRF-Token': getAuthenticityToken(),
    'X-Requested-With': 'XMLHttpRequest',
  });
}

/**
 * For use with window.fetch
 * @param {Object} options Object to be merged with jsonHeader options.
 * @returns {Object} The merged object.
 */
export function jsonHeader(options?: Record<string, string>): Record<string, string> {
  return Object.assign({}, options || {}, {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/json',
  });
}

/**
 * Lets fetch include credentials in the request. This includes cookies and other possibly sensitive
 * data.
 * Note: Never use for requests across (untrusted) domains.
 * @param options Object to be merged with safeCredentials options.
 * @returns The merged object.
 */
export function safeCredentials(options: any = {}): Record<string, string> {
  return Object.assign({}, options, {
    credentials: 'include',
    headers: Object.assign({}, authenticityHeader(), jsonHeader(), options.headers),
    mode: 'same-origin',
  });
}
